import { Router, NavigationEnd } from '@angular/router';
import { ToastService } from '@shared/components/toast';
import { Observable, switchMap, filter, first, catchError, of } from 'rxjs';
import { LOGIN_TOASTS } from '../constants/login.constant';

export const waitForNavigationEnd = (
  router: Router,
  toastService: ToastService,
): (<T>(source: Observable<T>) => Observable<NavigationEnd | null>) => {
  return function <T>(source: Observable<T>): Observable<NavigationEnd | null> {
    return source.pipe(
      switchMap(() =>
        router.events.pipe(
          filter(
            (event): event is NavigationEnd => event instanceof NavigationEnd,
          ),
          first(),
          catchError(() => {
            toastService.show(LOGIN_TOASTS['navigationError']);
            return of(null);
          }),
        ),
      ),
    );
  };
};
